import { batch, signal } from "@preact/signals-react"


export const tasks = signal([])
export const isLoading = signal(false)
export const selectedDate = signal(new Date().toISOString().slice(0, 10))


export const clearMyTasksSignals = () => batch(() => {
	tasks.value = []
	isLoading.value = false
	selectedDate.value = new Date().toISOString().slice(0, 10)
})
